const generateDDRecommendedUserCookie = (value: string | number) => {
  return `ddRecommendedUser=${value}; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/;`;
};

const removeDDRecommendedUserCookie = () => {
  return 'ddRecommendedUser=; expires=Mon, 01 Jan 2001 00:00:00 GMT; path=/;';
};

export { generateDDRecommendedUserCookie, removeDDRecommendedUserCookie };
